// @flow
import React from "react";

import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = {
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(255, 255, 255, .3)",
  },
  prog: {
    position: "absolute",
    fontSize: 20,
    top: "calc(50% - 20px)",
    left: "calc(50% - 20px)",
  },
};

const LoaderAbsolute = (props: Object) => {
  const classes = props.classes;
  return (
    <div className={classes.root}>
      <CircularProgress className={classes.prog} />
    </div>
  );
};

export default withStyles(styles)(LoaderAbsolute);
